import { RootState } from 'editor/src/store/index';

const getIsAProductSelected = (state: RootState) => state.variants.variationGroups.length > 0;

export default getIsAProductSelected;
